export const selectModifiersList = ['floating'];
